import React, { useState } from "react";
import { colors } from "../../../share/constants/enums";
import Button from "../../../components/common/button";
import { Link } from "react-router-dom";
import Yupup from "./../../../assets/icons/newLogo.svg";
import YupupScreen from "./../../../assets/icons/blackLogo.svg";
import { Input as InputField } from "antd";
import HeroImage from "../../../assets/icons/girls.svg";

const Congrats = () => {
  const [flag, setFlag] = useState(true);
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-primaryPurple lg:bg-white lg:grid lg:grid-cols-2 xl:grid xl:grid-cols-2">
      <div className="grid grid-cols-1 lg:flex lg:flex-col lg:items-start lg:justify-center lg:px-10">
        <div className="object-cover flex flex-row justify-center">
          <img
            className="block  md:block lg:hidden xl:hidden mt-6 h-14 md:h-17.7 lg:h-20"
            alt="yupup-logo"
            src={Yupup}
          />
        </div>
        <div className="object-cover w-full flex items-start mb-10">
          <img
            className="hidden sm:hidden md:hidden lg:block xl:block xl:h-13 xxl:block"
            alt="yupup-screen-logo"
            src={YupupScreen}
          />
        </div>
        <div className="flex flex-col space-y-3 items-center px-5 text-white lg:text-black xl:text-black xl:items-start xl:px-0">
          <div className="w-72 md:w-96">
            <p
              className="text-center md:text-center lg:text-start"
              style={{
                color: colors.background,
                fontFamily: "Satoshi-Regular, Helvetica",
                fontSize: "34px",
                fontWeight: 300,
                letterSpacing: "0.09px",
                lineHeight: "1.5",
              }}
            >
              Congratulations! Your YupUp Account Has Been Approved.
            </p>
          </div>
          <div className="lg:w-full">
            <p
              className="font-light text-center md:text-left"
              style={{
                color: colors.textBlack,
                fontFamily: "Satoshi-Regular, Helvetica",
                fontSize: "18px",
                letterSpacing: "0.027px",
                lineHeight: "25px",
                height: "50px",
              }}
            >
              To Complete Your Registration, Enter The Email You Used During
              Your Sign Up.
            </p>
          </div>
          <div className="lg:w-full">
            <InputField
              className={
                flag
                  ? "w-31 bg-inputFieldGrey hover:border-primaryBlue h-5.4 sm:w-31 md:w-40 lg:w-40"
                  : "w-31 hover:border-primaryBlue h-5.4 border-primaryBlue sm:w-31 md:w-40 lg:w-40"
              }
              placeholder="Email"
              onBlur={() => {
                setFlag(true);
              }}
              onFocus={() => {
                setFlag(false);
              }}
            />
          </div>
          <div className="lg:w-full">
            <Link to="/" className="no-underline">
              <Button
                title="Continue Registration"
                color={colors.primaryBlue}
                className="w-31 md:w-40 lg:w-40"
              />
            </Link>
          </div>
        </div>
      </div>
      <div className="hidden lg:flex justify-end">
        <img
          className="hidden sm:hidden md:block lg:block lg:h-screen"
          alt="hero-logo"
          src={HeroImage}
        />
      </div>
    </div>
  );
};

export default Congrats;
